var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoaderOverlay',{attrs:{"loading":_vm.loading}},[_c('img',{class:_vm.imgClass,attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }